/**
 * Maps employment type ids to i18n keys. Prefer short canonical keys where EN
 * defines them (FREELANCE, CTP, TEMPORARY) over deleted EMPLOYMENT_TYPE_* variants.
 */
export function getEmploymentTypeTranslationKey(id: string): string {
  switch (id) {
    case 'permanent':
      return 'EMPLOYMENT_TYPE_PERMANENT';
    case 'freelance':
      return 'FREELANCE';
    case 'ctp':
      return 'CTP';
    case 'temporary':
      return 'TEMPORARY';
    // Analytics hiring_category buckets (Cube / native facts).
    case 'contract':
      return 'CONTRACT';
    case 'secondment':
      return 'SECONDMENT';
    default:
      return `EMPLOYMENT_TYPE_${id.toUpperCase()}`;
  }
}
